import { toast } from "react-toastify";
import { getDiagnoszas } from "../services/solevaniaService";
import { useQuery } from "@tanstack/react-query";

export const useDiagnoszas = () => {
  return useQuery({
    queryKey: ["diagnoszas"],
    queryFn: getDiagnoszas,
  });
};
